import { FormikProps } from "formik";
import { useCallback, useContext, useState } from "react";
import { SubmitEventReport } from "../../../../../../generated/data-contracts";
import {
  AvisDescriptiveText,
  AvisSection,
} from "../../../../../shared/components/form";
import { AvisConfirmModalShort } from "../../../../../shared/components/modal";
import { AvisContext } from "../../../../../shared/context/AvisContext";
import {
  ReportClientEventsFormCheckbox,
  ReportClientEventsFormEditableList,
} from "./";

interface IReportClientEventsFormProps {
  bag: FormikProps<SubmitEventReport>;
  bagField: keyof SubmitEventReport;
  disabled: boolean;
  loading: boolean;
  allowBlankReport: boolean | undefined;
  periodFrom: Date | undefined;
  periodTo: Date | undefined;
  setRedirectToRowIndex: React.Dispatch<
    React.SetStateAction<number | undefined>
  >;
  navigateToProgramReport: (licenseClientEventId?: number) => void;
}
export function ReportClientEventsForm(
  props: Readonly<IReportClientEventsFormProps>,
) {
  const { bag, setRedirectToRowIndex, navigateToProgramReport } = props;

  const { res } = useContext(AvisContext);
  const [
    isConfirmSaveModalOpenForRowIndex,
    setIsConfirmSaveModalOpenForRowIndex,
  ] = useState<number | undefined>();

  const handleModalConfirm = useCallback(() => {
    bag.setFieldValue("submitReport", false);
    bag.submitForm().then(() => {
      setRedirectToRowIndex(isConfirmSaveModalOpenForRowIndex);
      setIsConfirmSaveModalOpenForRowIndex(undefined);
    });
  }, [bag, isConfirmSaveModalOpenForRowIndex, setRedirectToRowIndex]);

  return (
    <AvisSection title={res("licensees_LicenseReports_label_SectionData")}>
      <AvisDescriptiveText textKey="portal_LIC_LicenseReportForm2" />
      <ReportClientEventsFormCheckbox {...props} />
      <ReportClientEventsFormEditableList
        {...props}
        setIsConfirmSaveModalOpenForRowIndex={
          setIsConfirmSaveModalOpenForRowIndex
        }
        navigateToProgramReport={navigateToProgramReport}
      />
      <AvisConfirmModalShort
        isOpen={(isConfirmSaveModalOpenForRowIndex ?? -1) >= 0}
        title={res("licensees_LicenseReports_type2_ConfirmNavigate_Title")}
        content={res("licensees_LicenseReports_type2_ConfirmNavigate_Content")}
        confirm={handleModalConfirm}
        cancel={() => setIsConfirmSaveModalOpenForRowIndex(undefined)}
      />
    </AvisSection>
  );
}
